var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphFunctionPhysical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 15)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.032 49C1.21 49-.203 47.41.024 45.615 1.7 32.3 13.138 21.995 27 21.995c13.862 0 25.3 10.304 26.976 23.62C54.202 47.411 52.79 49 50.97 49H3.032z",
    fill: "#FFAB61"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFDBBB",
    cx: 27,
    cy: 10.609,
    rx: 10.681,
    ry: 10.609
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphFunctionPhysical);
export default __webpack_public_path__ + "static/media/icons_graph_function_physical.7b1cd8641345e758c9b3c7212a0d5cf1.svg";
export { ForwardRef as ReactComponent };